// @core/api/endpoints/webhook/get_webhook_stats.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  WebhookStatsResponse,
} from '../../../types/webhook';

const BASE_PATH = '/webhook';

/**
 * Get webhook statistics
 * Returns aggregated webhook statistics across all endpoints for the tenant, including total endpoints, delivery volumes, and overall success rates.
 */
export async function GetWebhookStats(
  params?: {
  },
  options?: RequestOptions
): Promise<WebhookStatsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/stats`;
  const requestOptions = options;
  return client.get<WebhookStatsResponse>(requestPath, { ...requestOptions, params });
}
